// removed by extract-text-webpack-plugin
module.exports = {"heading":"styles__heading__1uFJi","hustle":"styles__hustle__37mVi","subHeading":"styles__subHeading__PAMDp","briefButton":"styles__briefButton__1MqNC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FoldHome/styles.scss
// module id = 392
// module chunks = 0